/* -------------------------------------------

	Name:		Ellemilla
	Date:		2020/02/04
	Author:		http://psdhtml.me 

---------------------------------------------  */
/*global jQuery, document, yall, setTimeout */
var i = 0,
	img_lazy = document.querySelectorAll('img[data-src]:not(.dont)');
for (i = 0; i < img_lazy.length; i = i + 1) {
	img_lazy[i].classList.add('lazy');
}
document.addEventListener("DOMContentLoaded", function () {
	"use strict";
	yall({
		observeChanges: true
	});
});
jQuery(function () {
	"use strict";
	var
		$ = jQuery.noConflict(),
		html_tag = $(document.documentElement),

		footer_el = $(document.getElementById('footer-el')),
		nav_el = $(document.getElementById('nav-el')),
		top_el = $(document.getElementById('top-el')),

        module_help_el = $(document.getElementsByClassName('module-help-el')),
		schem_full_el = $(document.getElementsByClassName('scheme-full-el')),
		wishlist_btn = $(document.getElementsByClassName('wishlist-btn')),

		Default = {
			ellemilla: {
				links: function () {
					html_tag.on('click', function () {
						nav_el.add(footer_el).find('li.toggle').removeClass('toggle');
					});
				},
				top: function () {
					top_el.children('form').append('<a href="./" class="close" tabindex="-1">Close</a>').children('a.close').add(nav_el.find('a:has(i[class*="zoom"])')).on('click', function () {
						if (html_tag.is('.search2-active')) {
							html_tag.removeClass('search2-active');
						} else {
							html_tag.addClass('search2-active');
							top_el.children('form').find('input').focus();
						}
						return false;
					});
					/*top_el.append('<a href="#mobile" class="menu" role="button" aria-controls="mobile" aria-expanded="false" data-target="#mobile">' + nav_el.attr('aria-label') + ' <span>Close</span></a>').after('<nav id="mobile" aria-expanded="false" focusable="false" aria-hidden="true"></nav><a href="#mobile" id="shadow" role="button" tabindex="-1">Close</a>');*/
					top_el.append('<a href="#mobile" class="menu" role="button" aria-controls="mobile" aria-expanded="false" data-target="#mobile">' + nav_el.attr('aria-label') + ' <span>Close</span></a>').after('<nav id="mobile" aria-expanded="false" focusable="false" aria-hidden="true"></nav>');
					nav_el.each(function () {
						$(this).find('li.lang').appendTo($(this).children('ul:first-child'));
					});

              $('#bottom').remove();
			  // Als bottom menu childs heeft
			  if($('#nav-el .bottom-only li').length >= 1){
				footer_el.after('<nav id="bottom"><ul>' + top_el.find('#nav-el .bottom-only').html() + '</ul></nav>');
				html_tag.addClass('has-bottom');
			  }
              
              top_el.find('#nav-el .bottom-only').remove();
              


				},
				owl: function () {
					if (schem_full_el.length) {
                      schem_full_el.each(function () {
							if ($(this).children('li').length > 1 && $(this).hasClass('usp-big') == false) {
								$(this).addClass('mobile-hide').clone().removeClass('mobile-hide').addClass('mobile-only').insertAfter($(this));
								$(this).next('.mobile-only').owlLayout().children('.inner').owlCarousel({
									loop: true,
									nav: false,
									dots: false,
									autoplay: true,
									autoplayTimeout: 3000,
									autoHeight: true,
									lazyLoad: true,
									margin: 0,
									items: 1,
									onInitialized: function () {
										$(this.$element).owlSemantic();
									},
									onTranslated: function () {
										$(this.$element).owlSemantic();
									}
								});
							}
						});
					}
				},
				footer: function () {
                  footer_el.find('nav div:not(.dont):not(.ls-sw-languages) > ul').parent().addClass('sub').append('<a class="header-toggle" href="./"></a>').children('a.header-toggle').on('click', function () {
						if ($(this).parent().is('.toggle')) {
							$(this).attr('aria-expanded', false).parent().removeClass('toggle').children('ul').attr({
								'aria-hidden': true,
								'focusable': false
							});
						} else {
							$(this).attr('aria-expanded', false).parents('ul:first').children('li.toggle').removeClass('toggle').children('ul').attr({
								'aria-hidden': true,
								'focusable': false
							});
							$(this).attr('aria-expanded', true).parent().addClass('toggle').children('ul').attr({
								'aria-hidden': false,
								'focusable': true
							});
						}
						return false;
					});
				},
				miscellaneous: function () {
                  if ($('.template-product').length && window.location.href.indexOf("notify-me") > -1) {
                    setTimeout(function () {
                    	$('.template-product').find('.klaviyo-bis-trigger').first().click();
                      	var newurl = window.top.location.href.replace('#notify-me', '');
 						window.history.replaceState({ path: newurl }, '', newurl);
                    }, 300);
                  }
					if (wishlist_btn.length) {
						wishlist_btn.each(function () {
							$(this).on('click', function () {
								if ($(this).is('.swym-added')) {
									var element = $(this);
									setTimeout(function () {
										var tooltip = element.find('.swym-tooltip');
										tooltip.append('<span class="swym-tooltip-text">Add to wishlist</span>');
									}, 500);
								}
							})
						})
					}
                  	if ($(".popup-slider").length) {
                      $(".popup-slider").each(function() {
                        if ($(this).children().length > 1) {
                          $(this).owlLayout().children('.inner').owlCarousel({
                                loop: false,
                                nav: true,
                                dots: false,
                                autoHeight: false,
                                lazyLoad: true,
                                margin: 0,
                                items: 1,
                                onInitialized: function() {
                                  $(this.$element).owlSemantic();
                                },
                                onTranslated: function() {
                                  $(this.$element).owlSemantic();
                                },
                                onRefreshed: function() {
                                  $(this.$element).removeClass('loading');
                                }
                              });
                        }
                        $('body').on('register-instashop-clicks', function() {

                          $('a[data-popup="instashop"]').on('click', function() {
                            $('[data-title="instashop"]').find('.owl-carousel:first').addClass('loading');
                            $('[data-title="instashop"]').find('.owl-carousel:first').trigger('to.owl.carousel', [$(this).attr('data-slide-index'), 0]);
                          });
                        });
                        $('body').trigger('register-instashop-clicks');
                        if ($('a.open-instapost[data-popup="instashop"]').length) {
                            $('a.open-instapost[data-popup="instashop"]').last().click();
                            $.ajax({
                              url: '/cart/update.js',
                              method: 'post',
                              dataType: 'json',
                              data: {
                                attributes: {
                                  'open_instapost': ''
                                }
                              }
                            });
                          }
                      });
                    }

                  if ($('.featured-articles-slider').length) {
                    $(".featured-articles-slider").each(function() {
                        if ($(this).children().length > 1) {
                          $(this).owlLayout().children('.inner').owlCarousel({
                                loop: false,
                                nav: true,
                                dots: false,
                                autoHeight: false,
                                lazyLoad: true,
                                margin: 0,
                                items: 1,
                                onInitialized: function() {
                                  $(this.$element).owlSemantic();
                                },
                                onTranslated: function() {
                                  $(this.$element).owlSemantic();
                                }
                              });
                        }
                      });
                  }

				  	var paginaTaal = $('html').attr('lang');
					if(paginaTaal == "de"){
						Default.ellemilla.checklanguageselect();
					}
					
				},
              	checklanguageselect: function() {
                	var countrySelect = $('#country-select dd ul');
                	var countryActivated = false;

					var paginaTaal = $('html').attr('lang');
					if(paginaTaal == "de"){
						/*console.log("DEUTSCHLAND");
						countrySelect.find('li.selected').removeClass('selected');
						$("#country-select dd ul li[data-value='de']").addClass('selected').css("display","block");
						var selectedValue = "de";
						countryActivated = true;
						countrySelect.hide();
		                updateSelect();*/
						$("#country-select dd ul li[data-value='de']").click();
					}

		            $("#country-select dt span").click(function() {
		                countrySelect.toggle();
		            });

		            $("#country-select dd ul li").click(function() {
		            	countrySelect.find('li.selected').removeClass('selected');
		            	$(this).addClass('selected');
		                var selectedValue = $(this).attr("data-value");
		                countrySelect.hide();
		                updateSelect();
		            });

		            $(document).bind('click', function(e) {
		                var $clicked = $(e.target);
		                if (! $clicked.parents().hasClass("dropdown"))
		                    countrySelect.hide();
		            });


					// Hide all countries
					countrySelect.find('li').hide();

					// Get content blocks
					var serviceSection = $(".module-help-el > header p[data-country], .module-help-el  div[id*='shopify-section-ellemilla-klarna-faq'], .module-help-el  div[id*='shopify-section-ellemilla-shipping'], .module-help-el  div[id*='shopify-section-ellemilla-shipping'], .module-help-el  div[id*='shopify-section-ellemilla-return'], .module-help-el > div[id*='shopify-section-ellemilla-paymentmethods'], .module-help-el div[id*='shopify-section-ellemilla-return'], .module-help-el div[id*='shopify-section-ellemilla-contact-block']");

					serviceSection.each(function(){
						$(this).find('> section').removeClass('visible');
                      	if ($(this).is('p[data-country]')) { $(this).removeClass('visible');}
						// Get country
                        var classList = $(this).find('> section');
                        if (classList.length > 0) {
                          classList.each(function() {
                            var classList_def = $(this).attr("class").split(/\s+/);
                            // Make country visible in select
                            $.each(classList_def, function(index, country) {
                                countrySelect.find('li[data-value="' + country + '"]').show();
                            });
                          });


                          // Make first option active
                          if (!countryActivated) {
                              updateSelect();
                              countryActivated = true;
                          }
                      }
					});

					function updateSelect(){

						// Update country text based on select
						countrySelect.find('li.selected').each(function() {
							var countryName = $(this).html();
							$("#country-select dt span").html(countryName);

							var countryValue = $(this).attr("data-value");
							serviceSection.find('.visible').removeClass('visible');
                          	serviceSection.filter('.visible').removeClass('visible');

							serviceSection.find('.all, .' + countryValue).show().addClass('visible');
                          	if (serviceSection.is('p[data-country].' + countryValue)) { serviceSection.filter('.'+countryValue).show().addClass('visible'); }
						});
						// Hide the others if not .visible
						serviceSection.each(function(){
                          $(this).find('> section, .accordion[data-country], p[data-country]').each(function() {
                            if ( !$(this).hasClass('visible') ) {
                              $(this).hide();
							}
                          })
                          if ($(this).is('p[data-country]')) {
                            if ( !$(this).hasClass('visible') ) {
                              $(this).hide();
							}
                          }

						});

					}
                },
              	languageselect: function() {
                  Default.ellemilla.checklanguageselect();
                  $('#content.service .module-help-el header form select').on('change', function() {
                    Default.ellemilla.checklanguageselect();
                  });
				}
            }

		};

	setTimeout(function () {
		Default.ellemilla.top();
		Default.ellemilla.links();
		Default.ellemilla.owl();
		Default.ellemilla.footer();
		Default.ellemilla.miscellaneous();
        Default.ellemilla.languageselect();
	}, 0);


   /* custom from theme.liquid */

  // Pre-order app
    	var ELLEMILLA = ELLEMILLA || {};
			ELLEMILLA.available = ELLEMILLA.available || {};

			$( function() {
				var available = ELLEMILLA.available;
				

				

				$( '.direct-checkout, .buy-button a' ).one( "click", function(){
					
	      });

			});

				var HerokuServer = "https://shopify-de-pre-order.herokuapp.com/";
		    ELLEMILLA.getVariantMetafield = function( productId, variantId, callback ){
		      var URL = HerokuServer +"metadata/?productid="+ productId +"&variant="+ variantId;
		      $.getJSON( URL, callback );
		    }
		    ELLEMILLA.postVariantMetafield = function( productId, variantId, key, value ){
		      var URL = HerokuServer +"metadata/?productid="+ productId +"&variant="+ variantId;
		      jQuery.ajax({
		        url: URL,
		        method: "POST",
		        data: {
		          key: key,
		          value: value
		        }
		      }).success( function( data ){
		        console.log( data );
		      }).error( function( error ){
		        console.log( "Error" );
		      });
		    }
			// End pre-order app


            /* -------------------------------------------------------- */

			$('.readmore').click(function (event) {
				event.preventDefault();

				if($("body").hasClass("template-product")){
					var descriptionFull = document.querySelector('.product-description-full');
					var descriptionShort = document.querySelector('.product-description-short');
				} else if($("body").hasClass("template-page")){
					var descriptionFull = document.querySelector('.page-content-full');
					var descriptionShort = document.querySelector('.page-content-short');
				} else if($("body").hasClass("template-collection")){
					var descriptionFull = document.querySelector('.collection-content-full');
					var descriptionShort = document.querySelector('.collection-content-short');
				}

				

				/*$(descriptionShort).css({"display":"none"});
				$(descriptionFull).css({"display":"block"});*/

				$(descriptionShort).fadeOut("slow",function(){
					$(descriptionFull).fadeIn("slow");
				});
				


			  });
			  $('.readless').click(function (event) {
				event.preventDefault();
				if($("body").hasClass("template-product")){
					var descriptionFull = document.querySelector('.product-description-full');
					var descriptionShort = document.querySelector('.product-description-short');
				} else if($("body").hasClass("template-page")){
					var descriptionFull = document.querySelector('.page-content-full');
					var descriptionShort = document.querySelector('.page-content-short');
				}
				else if($("body").hasClass("template-collection")){
					var descriptionFull = document.querySelector('.collection-content-full');
					var descriptionShort = document.querySelector('.collection-content-short');
				}

				/*$(descriptionShort).css({"display":"block"});
				$(descriptionFull).css({"display":"none"});*/

				$(descriptionFull).fadeOut("slow",function(){
					if($(html).hasClass("mobile") && $("body").hasClass("template-product")){
						//$('html, body').scrollTo(".product-description-short");
						var elmnt = document.getElementsByClassName("accordion-a");
						elmnt[0].scrollIntoView({behavior: "smooth"});
					}
					$(descriptionShort).fadeIn("slow", function(){
						
					});
				});
			  });

			  document.addEventListener('rebuy:cart.add', function(event){ console.log('rebuy:cart.add event', event.detail); }); 
			  document.addEventListener('rebuy:cart.change', function(event){ 
				console.log('rebuy:cart.change event', event.detail); 
			  }); 



			  // Consent manager popup
			  $("footer .bottom .consentSettings").on("click",function(e){
				e.preventDefault();
				var x = __cmp('consentStatus');
				if(x.consentExists){
					__cmp('showScreen');
				}
			  })

			   // Shop The Look Label
			   /*$("#root .module-product .list-product .label_shopTheLook a").on("click",function(e) {*/
			   $(document).on("click tap touchstart", "#root .module-product .list-product .label_shopTheLook a", function(e){
					e.preventDefault();
					const mediaQuery = window.matchMedia('(max-width: 47.5em)');
					var scrollOffset = 150;
					if (mediaQuery.matches) {
						scrollOffset = 50;
					}
					$([document.documentElement, document.body]).animate({
							scrollTop: ($("#rebuySTLwrapperdiv").offset().top)-scrollOffset
						}, 1000);
				});
				// Megamenu hover fix
				
				$(document).on("#nav-el > ul > li.has-div > a, #nav-el > ul > li.has-div").on('touchstart touchend', function(e) {
						var $this = e.target;
						$(e.target).parent().children("div").addClass("hover_touch");
						//e.preventDefault();
						
						//$(this).next("toggle").addClass("TOGGLEME");
					});

				

			  // Shop The Look afbeelding in viewport houden
			  /*$.fn.isInViewport = function () {
				let elementTop = $(this).offset().top;
				let elementBottom = elementTop + $(this).outerHeight();
				let viewportTop = $(window).scrollTop();
				let viewportBottom = viewportTop + $(window).height();
				return elementBottom > viewportTop && elementTop < viewportBottom;
			  };

			  $(window).on("load resize scroll", function () {
				  if($("#shopTheLook")){
					if ($('.shopTheLookCollectieItem ').isInViewport()) {
						$('.shopTheLookCollectieItem').addClass("animate");
						console.log('success.')
					}
				}
			});*/
			  


});

/*!*/
